import { CustomVizOptionsSummaryDropdown } from 'libs/end-to-end/src/custom-viz/CustomVizDefinitions';
import { useCallback } from 'react';
import { CustomVizHookDropdownOptionsFilterByIdFn } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const usePayBenchmarkingOnDepartmentSelectedActions = ({
  filteredCustomVizDropdowns,
  setSelectedRole,
  setSelectableRoles,
  setSelectedDepartment,
}: {
  filteredCustomVizDropdowns: CustomVizHookDropdownOptionsFilterByIdFn;
  setSelectedDepartment: Setter<string | null>;
  setSelectedRole: Setter<string | null>;
  setSelectableRoles: Setter<CustomVizOptionsSummaryDropdown[]>;
}) => {
  return useCallback(
    (department: string | null) => {
      setSelectedDepartment(department);

      if (department === null) {
        setSelectedRole(null);
        setSelectableRoles([]);
        return;
      }

      const roleDropdownsToDisplay = filteredCustomVizDropdowns(
        `job_title_${department}`,
      );
      setSelectableRoles(roleDropdownsToDisplay);
    },
    [
      filteredCustomVizDropdowns,
      setSelectableRoles,
      setSelectedDepartment,
      setSelectedRole,
    ],
  );
};
